var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c(("card-" + (_vm.module.type)),{tag:"div",attrs:{"data":_vm.passThroughData,"default":_vm.passThroughDefault,"field":_vm.module}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }